import {FC, ImgHTMLAttributes} from 'react';
import {useLocale} from 'state/locale';

type I18nImageSource = {
    en: string;
    ja: string;
};

export type I18nImageProps<T = HTMLImageElement> = {
    src: I18nImageSource;
} & Omit<ImgHTMLAttributes<T>, 'src'>;

const I18nImage: FC<I18nImageProps> = ({alt, src, ...rest}) => {
    const locale = useLocale();

    return <img alt={alt} src={src[locale]} {...rest} />;
};

export default I18nImage;
